import type { OptionsType } from 'cookies-next';
import { getCookie as cnGetCookie, setCookie as cnSetCookie } from 'cookies-next';

import { Cookies } from '@/types';
import { getResponse } from '@/utils/get-response';

const isClient = (): boolean => typeof window !== 'undefined';

const getServerSideCookies = async () => {
  const { cookies } = await import('next/headers');
  return await cookies();
};

const getCookie = async (name: string) => {
  if (isClient()) {
    return cnGetCookie(name);
  }

  return cnGetCookie(name, { cookies: getServerSideCookies });
};

const setCookie = async (name: string, value: string, options?: OptionsType) => {
  if (isClient()) {
    return cnSetCookie(name, value);
  }

  return cnSetCookie(name, value, { cookies: getServerSideCookies, ...options });
};

const getLoggedUserId = async (): Promise<number> => {
  const raw = await getCookie(Cookies.LoggedUser);
  const cached = Number(raw);
  if (!Number.isNaN(cached)) {
    return cached;
  }

  // proxy.ts sets this cookie on every page request before it reaches here - this is only a fallback.
  const user = await getResponse('getApiV1AuthMe');
  return user.id;
};

export { getCookie, getLoggedUserId, setCookie };
